"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemActionGroup = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.ListItemActionGroup = styles_1.styled("div")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        flex: "0 0 auto",
        marginLeft: spacing(4),
        display: "flex",
        alignItems: "center",
        "& > :not(:first-child)": {
            marginLeft: spacing(2),
        },
    });
}, {
    name: "EuiListItemActionGroup",
});
//# sourceMappingURL=ListItemActionGroup.js.map